import React, { useState } from "react";
import styles from "./LanguagePage.module.css";
import { useHistory } from "react-router-dom";
import Header from "../components/Header";
import LanguageCard from "../components/LanguageCard";
import { useTranslation } from "react-i18next";


/**
 * Language Page
 */

export function LanguagePage() {
const {t} = useTranslation();

const history = useHistory();
const handleHeaderBackClick = () => {
    history.push("/");
};

return (
  <div className={styles.container}>
    <Header header={t("Settings")} onClick={handleHeaderBackClick} />
    <p className={styles.text1}>
      {t("This setting will change all of your apps")}
    </p>
    <LanguageCard />
    <hr />
    <p className={styles.text2}>
      {t("Below is a list of apps that have spanish")}
    </p>
    <ul className={styles.applist}>
      <li>Retail</li>
      <li>Digital Info System</li>
      <li>Info Center</li>
      <li>Homescreen</li>
      <li>Membership Sign-up</li>
      <li>Events</li>
      <li>WWG Store</li>
      <li>Help</li>
      <li>Settings</li>
    </ul>
  </div>
);
}

export default LanguagePage;